import { IOption, ISearchFilterSettings } from '@miq/shared-models';
export const connectFilters = (catalogs: ISearchFilterSettings[], userFilters: ISearchFilterSettings[]) => {
  // clear checked
  return catalogs
    .map(catalog => ({ ...catalog, filters: catalog.filters.map(f => ({ ...f, checked: false })) }))
    .map(({ title, sectionId, filters }) => {
      const userSelection = userFilters.find(usrFilter => usrFilter.title === title);
      if (!!userSelection) {
        return {
          title,
          sectionId,
          filters: [
            ...filters.map(filterItem =>
              Object.assign(
                filterItem,
                // MIQ-9410 display filter/column as they come from catalog endpoint
                {
                  // mark as checked if filterItem is included in user filter selection
                  checked: userSelection.filters.some(usrFilter => usrFilter.key === filterItem.key),
                }
              )
            ),
          ],
        };
      }
      return { title, sectionId, filters };
    });
};
export const addCheckedProperty = (filter: IOption): IOption => {
  return Object.defineProperty(filter, 'checked', {
    value: true,
    writable: true,
    enumerable: true,
    configurable: true,
  });
};
export const cleanUserFilters = (userFilters: ISearchFilterSettings[]): ISearchFilterSettings[] => {
  return userFilters.filter(toClean => toClean.filters.length > 0);
};
